export default __webpack_public_path__ + "static/media/1.9498a285.png";